import styled from 'styled-components'

export const MenticeLogo = styled.img.attrs(() => ({
  src: '/static/assets/logo.png',
  srcSet: '/static/assets/logo@2x.png 2x, /static/assets/logo@3x.png 3x',
}))`
`
